/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import React, {useEffect, useState} from "react";
import "./QrContainer.scss";
import {ExdsLink, ExdsText} from '@exds/core';
import ExpiredQr from './ExpiredQr';
import ErrorQr from './ErrorQr';
import {SOMETHING_WENT_WRONG} from '../../../../../constants/constants';

export default function QrContainer({ sloQrUrl, expirationTime, registerDeviceForSLO, error }) {
  const [timeLeft, setTimeLeft] = useState('');
  const [qrExpired, setQrExpired] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const currentTime = new Date();
      const expirationDate = new Date(expirationTime);
      const diff = expirationDate - currentTime;

      if (diff > 0) {
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);
        setTimeLeft(`${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds} sec`);
      } else {
        setTimeLeft('Expired');
        setQrExpired(true);
      }
    };

    const timerId = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timerId);
  }, [expirationTime]);

  return (
    <>
      {error === SOMETHING_WENT_WRONG &&
        <div className="qr-error-container">
          <ErrorQr/>
        </div>}
      {!error && qrExpired &&
        <div className="qr-error-container">
          <ExpiredQr/>
          <ExdsLink onClick={registerDeviceForSLO} className="retry-link" data-testid="testid-retry-link">Refresh QR
            Code</ExdsLink>
        </div>}
      {!error && !qrExpired &&
        <>
          <img
            src={`data:image/png;base64, ${sloQrUrl}`}
            alt="qrcode"
            className="qr-image" data-testid="testid-qrcode-image"
          />
          <ExdsText className="scan-text" primitive="p">
            Your unique QR code
          </ExdsText>
          <ExdsText className="timer">{timeLeft}</ExdsText>
        </>}
    </>
  );
};

